export default { type: 'spring', mass: 0.6 }
